import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { mobile_headers, headers, filters } from "./config";

const CustomerList = () => {

  return (
    <Table tableId="customers" title="Customer" icon={InventoryRoundedIcon} headers={headers} mobile_headers={mobile_headers} filters={filters} defaultSort="full_name" idKey="customer_id" fieldsToSearch={["Name", "Email", "Phone"]} exportCsv={true} />
  );
};

export default CustomerList;